import { render } from "./ClassSchCard.vue?vue&type=template&id=132839c4&scoped=true"
import script from "./ClassSchCard.vue?vue&type=script&lang=ts"
export * from "./ClassSchCard.vue?vue&type=script&lang=ts"

import "./ClassSchCard.vue?vue&type=style&index=0&id=132839c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-132839c4"

export default script